import { RefObject, useEffect, useRef } from 'react';
import { CameraOff } from 'lucide-react';

export function VideoPanel({
  stream,
  label,
  muted = true,
  videoRef
}: {
  stream?: MediaStream;
  label: string;
  muted?: boolean;
  videoRef?: RefObject<HTMLVideoElement>;
}) {
  const internalRef = useRef<HTMLVideoElement>(null);
  const ref = videoRef ?? internalRef;

  useEffect(() => {
    const video = ref.current;
    if (video) video.srcObject = stream ?? null;
    return () => {
      if (video) video.srcObject = null;
    };
  }, [ref, stream]);

  return (
    <div className="relative aspect-video overflow-hidden rounded-md bg-slate-900">
      {stream ? <video ref={ref} autoPlay playsInline muted={muted} className="h-full w-full object-cover" /> : <div className="grid h-full place-items-center text-slate-400"><CameraOff className="h-8 w-8" /></div>}
      <span className="absolute left-3 top-3 rounded-md bg-black/55 px-2 py-1 text-xs font-semibold text-white">{label}</span>
    </div>
  );
}
